import classNames from 'classnames';
import { HTMLRenderEl, HTMLRenderer } from './html-renderer.js';

export interface INote {
  text?: string;
  heading?: string;
}

interface IProps {
  notes: INote[];
  classes?: string;
}

const Header = (props: { header?: string }) => {
  const { header } = props;

  if (!header) {
    return null;
  }

  return <strong>{header}&nbsp;</strong>;
};

const handleNote = (note: INote, idx: number, length: number, classes?: string): JSX.Element => {
  const { text, heading } = note;

  const pClass = classNames({ 'u-mT-0': idx === 0 }, { 'u-mB-0': idx === length - 1 }, 'fineprint u-textGrey', classes);

  return (
    <p className={pClass} key={idx}>
      <Header header={heading} />
      <HTMLRenderer content={text ?? ''} elType={HTMLRenderEl.SPAN} />
    </p>
  );
};

/**
 * This component can be used to render notes from the current MetService API.
 * They mainly appear at the bottom of a tile as disclaimer text.
 * Potentially this could be used as a fallback if MobileDoc cannot be provided.
 * Currently used in the tides-timetable module.
 *
 * heading - will just be in a strong tag and before the text followed by a colon
 * text - is just text
 *
 * EXAMPLE Usage in the API
 * "notes": [
 *   {
 *     "heading": "Peak wind gust",
 *     "text": "The direction and speed of the highest gust that was recorded on the calendar day."
 *   },
 *   {
 *     "heading": "Temperature",
 *     "text": "The highest and lowest temperatures that were recorded on the calendar day."
 *   },
 *   {
 *     "heading": "Rainfall",
 *     "text": "The total rainfall that fell during the calendar day."
 *   },
 *   {
 *     "text": "The final message."
 *   }
 * ],
 */
export const RenderNotes = ({ notes, classes }: IProps) => (
  <>{notes?.map((note, idx) => handleNote(note, idx, notes.length, classes))}</>
);
